import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Box,
  Flex,
} from "@chakra-ui/react";
import { MdWarning } from "react-icons/md";

const formatFecha = (fecha) => {
  if (!fecha) return "";
  const d = new Date(fecha);
  const dia = String(d.getDate()).padStart(2, "0");
  const mes = String(d.getMonth() + 1).padStart(2, "0");
  const anio = d.getFullYear();
  return `${dia}/${mes}/${anio}`;
};

const ModalReactivarUsuario = ({ isOpen, onClose, onConfirm, usuario, isLoading }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="xl" pt={14} pb={6} px={6} maxW="md" position="relative" overflow="visible">
        <Flex
          position="absolute"
          top="-44px"
          left="50%"
          transform="translateX(-50%)"
          bg="brand.naranja"
          borderRadius="lg"
          p={4}
          align="center"
          justify="center"
        >
          <MdWarning size={44} color="white" />
        </Flex>

        <ModalBody textAlign="center" pb={4}>
          <Text
            color="brand.naranja"
            fontWeight="bold"
            fontSize="xl"
            mb={5}
          >
            Este usuario fue dado de baja
          </Text>

          <Text color="gray.600" mb={5} lineHeight="tall">
            El usuario{" "}
            <Text as="span" fontWeight="bold">
              {usuario?.nombre}
            </Text>{" "}
            fue dado de baja
            {usuario?.quienElimino ? (
              <>
                {" "}por{" "}
                <Text as="span" fontWeight="bold">
                  {usuario.quienElimino}
                </Text>
              </>
            ) : null}{" "}
            el{" "}
            <Text as="span" fontWeight="bold">
              {formatFecha(usuario?.fechaEliminacion)}
            </Text>
            .
          </Text>

          <Box bg="orange.50" borderRadius="md" p={4}>
            <Text color="gray.700" lineHeight="tall">
              ¿Querés volver a dar de alta a este usuario?
              <br />
              Se restaurarán sus datos anteriores.
            </Text>
          </Box>
        </ModalBody>

        <ModalFooter justifyContent="center" gap={4}>
          <Button
            variant="outline"
            borderColor="brand.naranja"
            color="brand.naranja"
            onClick={onClose}
            isDisabled={isLoading}
          >
            Cancelar
          </Button>
          <Button
            bg="brand.naranja"
            color="white"
            onClick={onConfirm}
            isLoading={isLoading}
            _hover={{ bg: "orange.500" }}
          >
            Reactivar usuario
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalReactivarUsuario;
